import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

@Component({
  selector: 'app-second-headline',
  templateUrl: './second-headline.component.html',
  styleUrls: ['./second-headline.component.scss'],
})
export class SecondHeadlineComponent implements OnInit {
  listSecondLine: any;
  formGroup: FormGroup;
  constructor(
    public copyService: CopyService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private abreCuentasService: AbreCuentasService,
    private requestService: RequestService,
    private biocatchService: BioCatchService,
    private parameterService: ParametersService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
  }

  ngOnInit() {
    const preLoginOnly = this.biocatchService.isEvidenteCase();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    if (product !== ProductsBiocatchEnum.VIV) {
      this.biocatchService.changeContext(StepBiocatchEnum.configuracion, product, this.biocatchService.isVivCn(product), preLoginOnly);
    }
    this.formGroup = new FormGroup({
      selection_second_headline: new FormControl('', Validators.required),
    });
    this.listSecondLine = [{
      label: this.copyService.copies.second_headline.second_yes,
      value: true,
    },
    {
      label: this.copyService.copies.second_headline.second_no,
      value: false,
    }];
    this.restrictiveList();
  }

  next() {
    this.abreCuentasService.setSecondHeadline({
      has_second_headline: this.formGroup.controls.selection_second_headline.value,
      has_incomes_second_headline: null,
    });
    const nextStep = this.formGroup.controls.selection_second_headline.value ? '200' : '201';
    const bitacoraEvent = `second headline_${ nextStep === '200' ? 'yes' : 'no' }`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.navigationService.nextStep(nextStep);
  }

  async restrictiveList() {
    const restrictive_params = this.parameterService.getSetting(OpEnum.RESTRICTIVE_PARAMETERS);
    const data_user = this.abreCuentasService.getDocumentInfo();
    const fullName = `${data_user.firstname} ${data_user.middlename} ${data_user.primary_lastname} ${data_user.second_lastname}`;
    const body = {
      data: {
        client_name: fullName,
        document : {
          number: data_user.document_number,
        },
        user_name:  restrictive_params.user_name,
        employee_id :  restrictive_params.employee_id,
        application :  restrictive_params.application,
        priority : restrictive_params.priority,
        reference_type :  restrictive_params.reference_type,
        transaction_type :  restrictive_params.transaction_type,
      },
    };
    await this.requestService.getRestrictiveList(body).then(async (res: any) => {
      const data: any = {
        list_query_status: {
          status_code: res.data.status_code,
        },
      };
      this.abreCuentasService.setProspectResponse(data);
      if (res.data.status_code === '5') {
        this.navigationService.navigateToGeneralInformation('107');
        return;
      }
    }).catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }
}
